import React, { FC } from 'react'

import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { toggleBigWidget } from '../DashboardSlice'
import { BigWidgetsName } from '../types'

import { RiskRewardRatioWidget } from './RiskRewardWidget'

export const DashboardRiskRewardRatioWrapper: FC = () => {
  const dispatch = useAppDispatch()

  const { bigWidgetsList, widgetsData } = useAppSelector(({ dashboard }) => dashboard)
  const { currentAccount } = useAppSelector(({ userAccounts }) => userAccounts)

  const potentialProfit = widgetsData?.riskRewardRatio?.potentialProfit
  const potentialLoss = widgetsData?.riskRewardRatio?.potentialLoss
  const currency = currentAccount?.currency as string

  const handleCheck = () => {
    dispatch(toggleBigWidget(BigWidgetsName.riskRewardRatio))
  }

  return (
    <RiskRewardRatioWidget
      potentialProfit={potentialProfit}
      potentialLoss={potentialLoss}
      currency={currency}
      handleCheck={handleCheck}
      isChecked={bigWidgetsList[BigWidgetsName.riskRewardRatio]}
    />
  )
}
